import _asyncToGenerator from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _wrapAsyncGenerator from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapAsyncGenerator";
import _awaitAsyncGenerator from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/awaitAsyncGenerator";
import _asyncIterator from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncIterator";
import _asyncGeneratorDelegate from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncGeneratorDelegate";
import getFilesAndDirectoriesFromDirectory from './getFilesAndDirectoriesFromDirectory.js';
/**
 * Polyfill for the new (experimental) getAsFileSystemHandle API (using the popular webkitGetAsEntry behind the scenes)
 * so that we can switch to the getAsFileSystemHandle API once it (hopefully) becomes standard
 */

function getAsFileSystemHandleFromEntry(entry, logDropError) {
  if (entry == null) return entry;
  return {
    kind: // eslint-disable-next-line no-nested-ternary
    entry.isFile ? 'file' : entry.isDirectory ? 'directory' : undefined,
    name: entry.name,
    getFile: function getFile() {
      return new Promise(function (resolve, reject) {
        return entry.file(resolve, reject);
      });
    },
    values: function values() {
      return _wrapAsyncGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var directoryReader, entries;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // If the file is a directory.
                directoryReader = entry.createReader();
                _context.next = 3;
                return _awaitAsyncGenerator(new Promise(function (resolve) {
                  getFilesAndDirectoriesFromDirectory(directoryReader, [], logDropError, {
                    onSuccess: function onSuccess(dirEntries) {
                      return resolve(dirEntries.map(function (file) {
                        return getAsFileSystemHandleFromEntry(file, logDropError);
                      }));
                    }
                  });
                }));

              case 3:
                entries = _context.sent;
                return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(entries), _awaitAsyncGenerator), "t0", 5);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    isSameEntry: undefined
  };
}

function createPromiseToAddFileOrParseDirectory(entry, relativePath, lastResortFile) {
  try {
    if (lastResortFile === void 0) {
      lastResortFile = undefined;
    }

    return _wrapAsyncGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      var getNextRelativePath, file, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, handle;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              getNextRelativePath = function getNextRelativePath() {
                return "".concat(relativePath, "/").concat(entry.name);
              }; // For each dropped item, - make sure it's a file/directory, and start deepening in!


              if (!(entry.kind === 'file')) {
                _context2.next = 17;
                break;
              }

              _context2.next = 4;
              return _awaitAsyncGenerator(entry.getFile());

            case 4:
              file = _context2.sent;

              if (!(file != null)) {
                _context2.next = 12;
                break;
              }

              ;
              file.relativePath = relativePath ? getNextRelativePath() : null;
              _context2.next = 10;
              return file;

            case 10:
              _context2.next = 15;
              break;

            case 12:
              if (!(lastResortFile != null)) {
                _context2.next = 15;
                break;
              }

              _context2.next = 15;
              return lastResortFile;

            case 15:
              _context2.next = 56;
              break;

            case 17:
              if (!(entry.kind === 'directory')) {
                _context2.next = 53;
                break;
              }

              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context2.prev = 20;
              _iterator = _asyncIterator(entry.values());

            case 22:
              _context2.next = 24;
              return _awaitAsyncGenerator(_iterator.next());

            case 24:
              _step = _context2.sent;
              _iteratorNormalCompletion = _step.done;
              _context2.next = 28;
              return _awaitAsyncGenerator(_step.value);

            case 28:
              _value = _context2.sent;

              if (_iteratorNormalCompletion) {
                _context2.next = 35;
                break;
              }

              handle = _value;
              return _context2.delegateYield(_asyncGeneratorDelegate(_asyncIterator(createPromiseToAddFileOrParseDirectory(handle, relativePath ? getNextRelativePath() : entry.name)), _awaitAsyncGenerator), "t0", 32);

            case 32:
              _iteratorNormalCompletion = true;
              _context2.next = 22;
              break;

            case 35:
              _context2.next = 41;
              break;

            case 37:
              _context2.prev = 37;
              _context2.t1 = _context2["catch"](20);
              _didIteratorError = true;
              _iteratorError = _context2.t1;

            case 41:
              _context2.prev = 41;
              _context2.prev = 42;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context2.next = 46;
                break;
              }

              _context2.next = 46;
              return _awaitAsyncGenerator(_iterator.return());

            case 46:
              _context2.prev = 46;

              if (!_didIteratorError) {
                _context2.next = 49;
                break;
              }

              throw _iteratorError;

            case 49:
              return _context2.finish(46);

            case 50:
              return _context2.finish(41);

            case 51:
              _context2.next = 56;
              break;

            case 53:
              if (!(lastResortFile != null)) {
                _context2.next = 56;
                break;
              }

              _context2.next = 56;
              return lastResortFile;

            case 56:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[20, 37, 41, 51], [42,, 46, 50]]);
    }))();
  } catch (e) {
    return Promise.reject(e);
  }
}
/**
 * Load all files from data transfer, and recursively read any directories.
 * Note that IE is not supported for drag-drop, because IE doesn't support Data Transfers
 *
 * @param {DataTransfer} dataTransfer
 * @param {*} logDropError on error
 */


export default function getFilesFromDataTransfer(_x, _x2) {
  return _getFilesFromDataTransfer.apply(this, arguments);
}

function _getFilesFromDataTransfer() {
  _getFilesFromDataTransfer = _wrapAsyncGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee4(dataTransfer, logDropError) {
    var fileSystemHandles, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _ref4, lastResortFile, fileSystemHandle;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _awaitAsyncGenerator(Promise.all(Array.from(dataTransfer.items,
            /*#__PURE__*/
            function () {
              var _ref2 = _asyncToGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee3(item) {
                var _fileSystemHandle, fileSystemHandle, getAsEntry;

                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        // TODO enable getAsFileSystemHandle API once we can get it working with subdirectories
                        // IMPORTANT: Need to check isSecureContext *before* calling getAsFileSystemHandle
                        // or else Chrome will crash when running in HTTP: https://github.com/transloadit/uppy/issues/4133
                        // if (window.isSecureContext && item.getAsFileSystemHandle != null)
                        // fileSystemHandle = await item.getAsFileSystemHandle()
                        // `webkitGetAsEntry` exists in all popular browsers (including non-WebKit browsers),
                        // however it may be renamed to getAsEntry() in the future, so you should code defensively, looking for both.
                        // from https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem/webkitGetAsEntry
                        getAsEntry = function getAsEntry() {
                          return typeof item.getAsEntry === 'function' ? item.getAsEntry() : item.webkitGetAsEntry();
                        }; // eslint-disable-next-line prefer-const


                        (_fileSystemHandle = fileSystemHandle) != null ? _fileSystemHandle : fileSystemHandle = getAsFileSystemHandleFromEntry(getAsEntry(), logDropError);
                        return _context3.abrupt("return", {
                          fileSystemHandle: fileSystemHandle,
                          lastResortFile: item.getAsFile() // can be used as a fallback in case other methods fail

                        });

                      case 3:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x3) {
                return _ref2.apply(this, arguments);
              };
            }())));

          case 2:
            fileSystemHandles = _context4.sent;
            _iteratorNormalCompletion2 = true;
            _didIteratorError2 = false;
            _iteratorError2 = undefined;
            _context4.prev = 6;
            _iterator2 = fileSystemHandles[Symbol.iterator]();

          case 8:
            if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
              _context4.next = 33;
              break;
            }

            _ref4 = _step2.value;
            lastResortFile = _ref4.lastResortFile;
            fileSystemHandle = _ref4.fileSystemHandle;

            if (!(fileSystemHandle != null)) {
              _context4.next = 27;
              break;
            }

            _context4.prev = 13;
            return _context4.delegateYield(_asyncGeneratorDelegate(_asyncIterator(createPromiseToAddFileOrParseDirectory(fileSystemHandle, '', lastResortFile)), _awaitAsyncGenerator), "t0", 15);

          case 15:
            _context4.next = 25;
            break;

          case 17:
            _context4.prev = 17;
            _context4.t1 = _context4["catch"](13);

            if (!(lastResortFile != null)) {
              _context4.next = 24;
              break;
            }

            _context4.next = 22;
            return lastResortFile;

          case 22:
            _context4.next = 25;
            break;

          case 24:
            logDropError(_context4.t1);

          case 25:
            _context4.next = 30;
            break;

          case 27:
            if (!(lastResortFile != null)) {
              _context4.next = 30;
              break;
            }

            _context4.next = 30;
            return lastResortFile;

          case 30:
            _iteratorNormalCompletion2 = true;
            _context4.next = 8;
            break;

          case 33:
            _context4.next = 39;
            break;

          case 35:
            _context4.prev = 35;
            _context4.t2 = _context4["catch"](6);
            _didIteratorError2 = true;
            _iteratorError2 = _context4.t2;

          case 39:
            _context4.prev = 39;
            _context4.prev = 40;

            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }

          case 42:
            _context4.prev = 42;

            if (!_didIteratorError2) {
              _context4.next = 45;
              break;
            }

            throw _iteratorError2;

          case 45:
            return _context4.finish(42);

          case 46:
            return _context4.finish(39);

          case 47:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[6, 35, 39, 47], [13, 17], [40,, 42, 46]]);
  }));
  return _getFilesFromDataTransfer.apply(this, arguments);
}